import { GlCollapsibleListbox } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { INCIDENTS_I18N as i18n, STATUS_ACKNOWLEDGED, STATUS_TRIGGERED, STATUS_RESOLVED } from '../../constants';
import { getStatusLabel } from '../../utils';
const STATUS_LIST = [
    STATUS_TRIGGERED,
    STATUS_ACKNOWLEDGED,
    STATUS_RESOLVED
];
export default {
    name: 'EscalationStatus',
    i18n,
    STATUS_LIST,
    components: {
        GlCollapsibleListbox
    },
    props: {
        value: {
            type: String,
            required: false,
            default: null,
            validator (value) {
                return [
                    ...STATUS_LIST,
                    null
                ].includes(value);
            }
        },
        headerText: {
            type: String,
            required: false,
            default: null
        },
        statusSubtexts: {
            type: Object,
            required: false,
            default () {
                return {};
            }
        }
    },
    emits: [
        'input'
    ],
    computed: {
        statusDropdownOptions () {
            return this.$options.STATUS_LIST.map((status)=>({
                    text: this.getStatusLabel(status),
                    subtext: this.statusSubtexts[status],
                    value: status
                }));
        },
        currentStatusLabel () {
            return this.getStatusLabel(this.value);
        }
    },
    methods: {
        // eslint-disable-next-line vue/no-unused-properties -- show() is part of the component's public API
        show () {
            this.$refs.dropdown.open();
        },
        // eslint-disable-next-line vue/no-unused-properties -- hide() is part of the component's public API
        hide () {
            this.$refs.dropdown.close();
        },
        getStatusLabel
    }
};
